import {
  faLightbulb,
  faPeopleGroup,
  faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";
import {
  AboutCardContainer,
  AboutCardImage,
  AboutCardTextBox,
  AboutCardTextBoxIntroTitle,
  AboutCardTextBoxText,
  AboutCardTextBoxTitle,
  Card,
  CardContact,
  CardContainer,
  CardIcon,
  CardTitle,
} from "./AboutStyles";

function About() {
  return (
    <>
      <CardContainer>
        <Card>
          <CardIcon icon={faLightbulb} size={"3x"} />
          <div>
            <CardTitle>Smart Flex</CardTitle>
            <p style={{ color: "#17224d" }}>
              Smart Flex levert de juiste zorgprofessionals op locatie, precies
              wanneer en waar ze nodig zijn.
            </p>
          </div>
        </Card>
        <Card>
          <CardIcon icon={faPeopleGroup} size={"3x"} />
          <div>
            <CardTitle>Smart Team</CardTitle>
            <p style={{ color: "#17224d" }}>
              Het Smart Team neemt de regie over een zorglocatie. We leveren een
              team van zorgprofessionals bestaande uit verschillende
              disciplines.
            </p>
          </div>
        </Card>
        <CardContact href="tel:+31850607774">
          <CardIcon
            icon={faPhoneVolume}
            size={"3x"}
            style={{ color: "white" }}
          />
          <div style={{ marginLeft: "20px", marginRight: "20px" }}>
            <h3 style={{ color: "white", marginBottom: "20px" }}>
              Neem contact op
            </h3>
            <h3 style={{ color: "#003082" }}>+31850607774</h3>
          </div>
        </CardContact>
      </CardContainer>

      <AboutCardContainer>
        <AboutCardImage src="/assets/4.jpg" alt="Smart Personeel" />
        <AboutCardTextBox>
          <AboutCardTextBoxIntroTitle>Over Smart</AboutCardTextBoxIntroTitle>
          <AboutCardTextBoxTitle>Uw partner in de zorg</AboutCardTextBoxTitle>
          <AboutCardTextBoxText>
            De zorg staat voor grote uitdagingen. Personeelstekorten, complexe
            zorgvragen en de behoefte aan flexibiliteit vragen om slimme
            oplossingen. Bij Smart-personeel begrijpen we die uitdagingen en
            bieden we een breed scala aan diensten om zorgorganisaties en
            zorgprofessionals te ondersteunen. Of u nu op zoek bent naar de
            juiste mensen voor uw organisatie, of zelf op zoek bent naar een
            nieuwe stap in uw carrière. Wij staan voor u klaar.
          </AboutCardTextBoxText>
        </AboutCardTextBox>
      </AboutCardContainer>
    </>
  );
}

export default About;
